import Image from "next/image";
import Head from "next/head";
import styles from "./mains-crash-course.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
// import Interest from "../../components/might-be-interest";
import crashcourse from "../../assets/images/upsc/upsc-mainscrash-course-web-banner.jpg";
import Mobcrashcourse from "../../assets/images/upsc/upsc-mainscrash-course-mob-banner.jpg";
import Link from "next/link";
import check from "../../assets/images/upsc/check.png";

const Two_Year_Classroom_Programme = () => {

    const feestructure3 =[
    {batch:"Regular(Hybrid)",
    start:( <> <div>15th June 2026</div> <div>02:00 pm - 07:30 pm</div></>), 
    fee:(<><div>₹36,000</div> </>), 
    pay :(<a href="https://admissionsv1.shankariasacademy.com/?center= &coursetype=Upsc" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.normalbutton} `}> Pay Now</button></a>)},
    ]

    return (  
        <>
  
        <Head>
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index, nofollow" />
            <meta name="robots" content="index, nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>Shankar IAS Academy | UPSC Mains Crash Course 2026</title>
            <meta name="title" content="Shankar IAS Academy | UPSC Mains Crash Course 2026" />
            <meta name="keywords" content="UPSC Mains Crash Course ,UPSC Crash Course for Mains ,UPSC GS Mains Crash Course ,Mains GS Crash Course,Online UPSC Mains Crash Course, UPSC Mains Crash Course Syllabus,UPSC Mains Crash Course Fees, UPSC Mains Crash Course Admission , UPSC Mains Crash Course Details ,Best Crash Course for UPSC Mains  " />
            <meta name="description" content="Join Shankar IAS Academy’s UPSC Mains Crash Course 2026. Intensive revision, answer writing, expert mentorship & test series for final preparation." />
            <link rel="canonical" href="https://www.shankariasacademy.com/upsc-mains-crash-course/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Shankar IAS Academy | UPSC Mains Crash Course 2026" />
            <meta property="og:description" content="Join Shankar IAS Academy’s UPSC Mains Crash Course 2026. Intensive revision, answer writing, expert mentorship & test series for final preparation." />
            <meta property="og:url" content="https://www.shankariasacademy.com/upsc-mains-crash-course/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

        <Navbar title="upsc" />
        
        <div className="container">
            <div className="row">
                <div className="col pt-3 pt-md-4">
                    <h1 className={`${styles.pagemaintitle}`}>UPSC Mains Crash Course 2026</h1>
                </div>
            </div>
            <div className="row d-none d-md-block">
                <div className="col mb-3">
                <Image
                    src={crashcourse}
                    alt="UPSC Mains Crash Course 2024"
                    title="UPSC Mains Crash Course 2024"
                    className="img-fluid w-100"
                />
                </div> 
            </div> 
            <div className="row d-block d-md-none">
            <div className="col mb-3">
                <Image
                    src={Mobcrashcourse}
                    alt="UPSC Mains Crash Course 2024"
                    title="UPSC Mains Crash Course 2024"
                    className="img-fluid w-100"
                />
                </div>
            </div>
        </div>

        {/* table */}

        <section  id="courseandfees">
                <div className="container pt-xl-4 pb-4" >
                    <div className="row">
                        <div class="py-2" style={{backgroundColor: "#001e62"}}><h2 className={`${styles.tabletitle}`}>UPSC Mains Crash Course 2026</h2></div>
                        
                        <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#eaf2fb" }}>Batch</div>
                        <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#eaf2fb" }}>Starts on</div>
                        <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#eaf2fb" }}>Fee</div>
                        <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#eaf2fb" }}>Admission</div>
                        <hr/>
                    </div>
                    
                    {feestructure3.map((item,index)=>(
                        <div className={`${styles.facultyborder3} row`}>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Batch</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-0`}>{item.batch}</div>

                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-0`}>{item.start}</div>

                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Fee</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-0`}>{item.fee}</div>
                      
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Payment</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-2 text-center pt-2 pt-md-2`}>
                              {item.pay}
                            </div>
                        <hr/>

                        </div>
                    ))} 
                    
                </div>
	    </section> 

        <div className="container pt-2 pt-lg-3 mb-4 mb-md-5">
            <div className="row" id="optionaltest">
                <div className="col-xl-4 col-md-6 col-12 py-xl-2 pt-3">
                    <div className="h-100" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                       <ul>
                            <li className={`${styles.sectiontitle2} mb-0`}>Classes on<br/> Mains only subjects</li>                     
                        </ul>
                    </div>
                </div>

                <div className="col-xl-4 col-md-6 col-12 py-xl-2 pt-3">
                    <div className="h-100" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <ul>
                             <li className={`${styles.sectiontitle2} mb-0`}>Mains 2026<br/> Test series</li>                               
                        </ul>
                    </div>
                </div>

                <div className="col-xl-4 col-md-6 col-12 py-xl-2 pt-3">
                    <div className="h-100" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <ul>
                            <li className={`${styles.sectiontitle2} mb-0`}>Books for<br/> Mains only subjects</li>                               
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        {/* <div className="container-fluid d-none d-lg-block"
                        style={{background: "transparent linear-gradient(180deg, #F4F6F8 0%, #F4F6F8 75%, #F4F6F800 100%) 0% 0% no-repeat padding-box", opacity: "1",}}>
                        <div className="container">                   
                            <div className="row ">
                                <div className="col-12 col-xl-6 col-lg-8 col-md-10 mx-auto text-start mb-5">
                                <h2 className={`${styles.sectiontitle} pt-2`}>Mains Crash Course Details </h2>
                                    <hr />
                                    <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />NUMBER OF SESSIONS – 70+</p>
                                    <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />COURSE DURATION – 40 days</p>
                                    <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />NUMBER OF TEST-25 TEST</p>
                                    <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />Subjects to be covered:</p>
                                    
                                    <div className="row">
                                        <div className="col-md-12 col-lg-8 col-xl-8 col-12 pt-3 pe-xl-0">
                                        <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Governance</p>
                                        <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Agriculture</p>
                                        <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Ethics</p>
                                        <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Internal security</p>
                                        <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Society in India</p>
                                        <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Post Independence Consolidation</p>
                                        </div> 
                                        <div className="col-md-12 col-lg-6 col-xl-4 col-12 pt-3 ps-xl-0">
                                        <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Bilateral Relations</p>
                                        <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Economics</p>
                                        <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>World History</p>
                                        <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Essay</p>
                                        <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>World Constitution</p>
                                        <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Rights Issues</p>
                                        </div>
                                    </div>
                                    
                                </div>

                                
                            </div>
                        </div>
        </div> */}

        {/* Mobile View */}

        {/* <div className="container-fluid d-block d-md-none"
                style={{background: "transparent linear-gradient(180deg, #F4F6F8 0%, #F4F6F8 75%, #F4F6F800 100%) 0% 0% no-repeat padding-box", opacity: "1",}}>
                  <div className="container">                   
                    <div className="row ">
                        <div className="col-12 col-xl-6 col-lg-8 col-md-10 mx-auto text-start mb-5">
                        <h2 className={`${styles.sectiontitle} pt-2`}>Mains Crash Course Details </h2>
                            <hr />
                            <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />NUMBER OF SESSIONS – 70+</p>
                            <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />COURSE DURATION – 40 days</p>
                            <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />NUMBER OF TEST-25 TEST</p>
                            <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />Subjects to be covered:</p>
                             
                              <div className="row">
                                <div className="col-md-12 col-lg-8 col-xl-8 col-12 pt-3 pe-xl-0">
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Governance</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Agriculture</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Ethics</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Internal security</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Society in India</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Post Independence Consolidation</p>
                                </div> 
                                <div className="col-md-12 col-lg-6 col-xl-4 col-12 pt-3 ps-xl-0">
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Bilateral Relations</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Economics</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>World History</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Essay</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>World Constitution</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Rights Issues</p>
                                </div>
                              </div>
                              
                        </div>

                        
                      </div>
                  </div>
        </div>  */}

        
    
        <Footer />                      
        </>
    )
}
export default Two_Year_Classroom_Programme
